import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";

export const ACTIVATION_METADATA = "ACTIVATION_METADATA";

export const useActivationMetadataQuery = () => {
    return useQuery({
        queryKey: [ACTIVATION_METADATA],
        queryFn: async () => {
            const api = createActivationApi();

            return api.homeWithData.getActivationMetadata();
        },
        refetchOnMount: true,
    });
};
